import { render, staticRenderFns } from "./charge-detail.vue?vue&type=template&id=af080416&scoped=true&"
import script from "./charge-detail.vue?vue&type=script&lang=ts&"
export * from "./charge-detail.vue?vue&type=script&lang=ts&"
import style0 from "./charge-detail.vue?vue&type=style&index=0&id=af080416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af080416",
  null
  
)

export default component.exports